import { Component, OnInit, Input, ViewEncapsulation, ViewChild, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from "src/app/_services";
import { MovService } from "src/app/_services/mov.service";
import { PopConteudo } from "src/app/_models/PopConteudo";
import { ToolbarService, LinkService, ImageService, HtmlEditorService, TableService, RichTextEditorComponent } from '@syncfusion/ej2-angular-richtexteditor';

import { enableRipple } from '@syncfusion/ej2-base';
import { L10n } from '@syncfusion/ej2-base';
import { PopConteudoUpdate } from "src/app/_models/PopConteudoUpdate";
enableRipple(true);


L10n.load({
  'pt-BR': {
      'richtexteditor': {
          alignments: "Ausrichtungen",
          justifyLeft: "Linksbündig",
          justifyCenter: "Im Zentrum anordnen",
          justifyRight: "Rechts ausrichten",
          justifyFull: "Justize ausrichten",
          fontName: "Schriftartenname",
          fontSize: "Schriftgröße",
          fontColor: "Schriftfarbe",
          backgroundColor: "Hintergrundfarbe",
          bold: "Fett gedruckt",
          italic: "Kursiv",
          underline: "Unterstreichen",
          strikethrough: "Durchgestrichen",
          clearFormat: "Format löschen",
          clearAll: "Alles löschen",
          cut: "Schnitt",
          copy: "Kopieren",
          paste: "Einfügen",
          unorderedList: "Liste mit Aufzählungszeichen",
          orderedList: "Nummerierte Liste",
          indent: "Einzug vergrößern",
          outdent: "Einzug verringern",
          undo: "Rückgängig machen",
          redo: "Wiederholen",
          superscript: "Hochgestellt",
          subscript: "Index",
          createLink: "Hyperlink einsetzen",
          openLink: "Verbindung öffnen",
          editLink: "Link bearbeiten",
          removeLink: "Link entfernen",
          image: "Bild einfügen",
          replace: "Ersetzen",
          align: "Ausrichten",
          caption: "Bildbeschreibung",
          remove: "Löschen",
          insertLink: "Link einfügen",
          display: "Anzeige",
          altText: "alternativer Text",
          dimension: "Größe ändern",
          fullscreen: "Maximieren",
          maximize: "Maximieren",
          minimize: "Minimieren",
          lowerCase: "Kleinbuchstaben",
          upperCase: "Großbuchstaben",
          print: "Drucken",
          formats: "Formate",
          sourcecode: "Codeansicht",
          preview: "Vorschau",
          viewside: "Ansicht Seite",
          insertCode: "Code eingeben",
          linkText: "Text anzeigen",
          linkTooltipLabel: "Titel",
          linkWebUrl: "Webadresse",
          linkTitle: "Titel eingeben",
          linkurl: "http://example.com",
          linkOpenInNewWindow: "Link in neuem Fenster öffnen",
          linkHeader: "Link einfügen",
          dialogInsert: "Einfügen",
          dialogCancel: "Stornieren",
          dialogUpdate: "Aktualisieren",
          imageHeader: "Bild einfügen",
          imageLinkHeader: "Sie können auch einen Link aus dem Web bereitstellen",
          mdimageLink: "Bitte geben Sie eine URL für Ihr Bild an",
          imageUploadMessage: "Bild hier ablegen oder hoch laden",
          imageDeviceUploadMessage: "Klicken Sie hier zum Hochladen",
          imageAlternateText: "Alternativer Text",
          alternateHeader: "alternativer Text",
          browse: "Durchsuche",
          imageUrl: "http://example.com/image.png",
          imageCaption: "Bildbeschriftung",
          imageSizeHeader: "Bildgröße",
          imageHeight: "Höhe",
          imageWidth: "Breite",
          textPlaceholder: "Text eingeben",
          inserttablebtn: "Tabelle einfügen",
          tabledialogHeader: "Tabelle einfügen",
          tableWidth: "Breite",
          cellpadding: "Zellauffüllung",
          cellspacing: "Zellabstand",
          columns: "Anzahl der Spalten",
          rows: "Reihenanzahl",
          tableRows: "Tabellenzeilen",
          tableColumns: "Tabellenspalten",
          tableCellHorizontalAlign: "Horizontale Ausrichtung der Tabellenzelle",
          tableCellVerticalAlign: "Vertikale Ausrichtung der Tabellenzelle",
          createTable: "Tabelle erstellen",
          removeTable: "Tabelle entfernen",
          tableHeader: "Tabellenkopfzeile",
          tableRemove: "Tabelle entfernen",
          tableCellBackground: "Tabellenzellenhintergrund",
          tableEditProperties: "Eigenschaften der Tabellenbearbeitung",
          styles: "Styles",
          insertColumnLeft: "Spalte links einfügen",
          insertColumnRight: "Spalte rechts einfügen",
          deleteColumn: "Spalte löschen",
          insertRowBefore: "Zeile vor einfügen",
          insertRowAfter: "Zeile einfügen nach",
          deleteRow: "Zeile löschen",
          tableEditHeader: "Tabelle bearbeiten",
          TableHeadingText: "Überschrift",
          TableColText: "Col",
          imageInsertLinkHeader: "Link einfügen",
          editImageHeader: "Bild bearbeiten",
          alignmentsDropDownLeft: "Linksbündig",
          alignmentsDropDownCenter: "Im Zentrum anordnen",
          alignmentsDropDownRight: "Rechts ausrichten",
          alignmentsDropDownJustify: "Justize ausrichten",
          imageDisplayDropDownInline: "In der Reihe",
          imageDisplayDropDownBreak: "Brechen",
          tableInsertRowDropDownBefore: "Reihe vorher einfügen",
          tableInsertRowDropDownAfter: "Zeile danach einfügen",
          tableInsertRowDropDownDelete: "Zeile löschen",
          tableInsertColumnDropDownLeft: "Spalte links einfügen",
          tableInsertColumnDropDownRight: "Spalte rechts einfügen",
          tableInsertColumnDropDownDelete: "Spalte löschen",
          tableVerticalAlignDropDownTop: "Top ausrichten",
          tableVerticalAlignDropDownMiddle: "Mitte ausrichten",
          tableVerticalAlignDropDownBottom: "Unten ausrichten",
          tableStylesDropDownDashedBorder: "Gestrichelte Grenzen",
          tableStylesDropDownAlternateRows: "Alternative Zeilen"
         }
     }
});






@Component({
  selector: 'text-editor-mov',
  templateUrl: './text-editor-mov.component.html',
  styleUrls: ['./text-editor-mov.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, TableService]
})

export class TextEditorMovComponent implements OnInit, OnDestroy {

  /* Propriedades */

  @ViewChild('rtePop') public rtePop: RichTextEditorComponent;
  //@Input() notifier: Subject<string>;
  private id: number;
  public loading = false;
  public popConteudo: PopConteudo;
  public htmlContent = "";
  public subtitulo = "";
  public btnAtualizDisabled = true;

  public tools: object = {
    items: [
      'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
      'LowerCase', 'UpperCase', '|', 'Undo', 'Redo', '|',
      'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
      'Indent', 'Outdent', '|', 'CreateLink', 'CreateTable',
      'Image', '|', 'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen']
  };


  public insertImageSettings: object = {
    allowedTypes: ['.jpg', '.png'],
    saveFormat: "Base64"
  };


  public pasteCleanupSettings: object = {
    prompt: false,
    plainText: false,
    keepFormat: false,
    deniedTags: ['a', 'img[src]'],
    deniedAttrs: ['class', 'title', 'id'],
    allowedStyleProps: ['color', 'margin', 'font-size']
  };



  /* Construtor */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiMovService: MovService,
    private toast: ToastrService) {
    this.route.queryParams.subscribe(params => {
      let idParam = this.route.snapshot.paramMap.get('idPopConteudo');
      this.id = Number(idParam);
    });
  }



  /* Métodos privados */
  private carregarPopConteudo(): void {
    this.fecharMensagens();
    this.loading = true;
    this.apiMovService.getPopConteudoById(this.id)
      .subscribe(
        rtmc => this.popConteudo = rtmc.data,
        error => {
          this.alertService.error(error);
          this.loading = false;
        }
        , () => {
          this.loading = false;
          if(this.popConteudo != null){
            this.htmlContent = this.popConteudo.html;
            this.subtitulo = this.popConteudo.subtitulo;
            this.btnAtualizDisabled = false;
          }
          else{
            this.exibirMensagemAlerta("Pop não localizado!", "Verificar os problemas abaixo:");
          }
        });
  }
  private exibirMensagemAlerta(msgAlerta: string, msgTitulo: string) {    
    this.toast.warning(msgAlerta, msgTitulo);   
  }
  private exibirMensagemSucesso(msgTitulo: string) {    
    this.toast.success(msgTitulo);   
  }
  private fecharMensagens(){
    this.toast.clear();
  }
  private obterMensagemFormatada(erros: string[]): string {
    var msgFormatada = "<div>Verificar os problemas abaixo: <br />";
    erros.forEach(function (e) {
      msgFormatada += "<br />*" + e;
    });
    msgFormatada += "</div>";

    return msgFormatada;
  }



  /* Métodos públicos */
  public atualizarPopConteudo(): void {
    this.fecharMensagens();
    let popConteudoUpdate = new PopConteudoUpdate(this.id, this.htmlContent);
    this.loading = true;
    this.apiMovService.putPopConteudo(popConteudoUpdate)
      .subscribe(
        data => {
          this.loading = false;
          if (data.success){
            let commandResult = data.data;
            if (commandResult.success){
              this.exibirMensagemSucesso("Conteúdo atualizado com sucesso!");
            }
            else{
              let msgsErro = this.obterMensagemFormatada(commandResult.data)
              this.exibirMensagemAlerta(msgsErro, "Não foi possível atualizar o conteúdo!");
            }
          }
        });
  }  



  /* Eventos */
  ngOnInit(): void {
    this.fecharMensagens();
    this.carregarPopConteudo();
  }
  ngOnDestroy() { 
    this.fecharMensagens();
   }

}